import { render, staticRenderFns } from "./RoleCharacteristicsPanel.vue?vue&type=template&id=bcd27ea4"
import script from "./RoleCharacteristicsPanel.vue?vue&type=script&lang=js"
export * from "./RoleCharacteristicsPanel.vue?vue&type=script&lang=js"
import style0 from "./RoleCharacteristicsPanel.vue?vue&type=style&index=0&id=bcd27ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports